import React from 'react';

import { List, Typography } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ReserveStateSchema, WarehouseFlowSchema } from '@app/models/orders';

import { ListItem } from '@components/ListItem';
import { Paper } from '@components/Paper';

import { ReserveStatusTag } from './components/ReserveStatusTag';
import { WarehouseFlowTag } from './components/WarehouseFlowTag';

interface IProps {
  reserveState?: ReserveStateSchema | null;
  warehouseFlow?: WarehouseFlowSchema | null;
  warehouseFlowView?: boolean;
}

export const WarehouseStatusBlock: React.FC<IProps> = ({ reserveState, warehouseFlow, warehouseFlowView }) => {
  const orderT = useTranslation(NSKeys.order);

  if (!reserveState?.status) {
    return null;
  }

  return (
    <Paper>
      <Typography.Title level={3}>{orderT.t('blockWarehouseFlow.label')}</Typography.Title>
      <List style={{ maxWidth: 600, margin: '20px 0 0 0' }}>
        <ReserveStatusTag reserveState={reserveState} />
        {warehouseFlowView && warehouseFlow && <WarehouseFlowTag flow={warehouseFlow} />}
      </List>
    </Paper>
  );
};
